import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Languages } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
interface Lang {
  language?: string;
  rating?: number;
}

@Component({
  selector: 'app-add-languages',
  templateUrl: './add-languages.component.html',
  styleUrls: ['./add-languages.component.css']
})
export class AddLanguagesComponent {
  public language = {languages: [] as Array<Lang>, resume_id: '' } as Languages;
  public languageList = [
    {language: 'Add New', rating: 0},
    {language: 'Chinese', rating: 0},
    {language: 'Spanish', rating: 0},
    {language: 'English', rating: 0},
    {language: 'Hindi', rating: 0},
    {language: 'Arabic', rating: 0},
    {language: 'Portuguese', rating: 0},
    {language: 'Bengali', rating: 0},
    {language: 'Russian', rating: 0},
    {language: 'Japanese', rating: 0},
    {language: 'Punjabi', rating: 0},
    {language: 'Javanese', rating: 0},
    {language: 'German', rating: 0},
    {language: 'Korean', rating: 0},
    {language: 'French', rating: 0},
    {language: 'Telugu', rating: 0},
    {language: 'Marathi', rating: 0},
    {language: 'Turkish', rating: 0},
    {language: 'Tamil', rating: 0},
    {language: 'Vietnamese', rating: 0},
    {language: 'Urdu', rating: 0}
  ];
  constructor(
    private router: Router,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService
  ) {
    const resume_id = this.localStorageService.get('resume_id').toString();
    this.language.resume_id = resume_id;
    this.resumeService.getResumeById(resume_id).subscribe(res => {
      this.language.languages = res.Resume.languages || [];
    });
  }
  addMore(lang?: Lang) {
    this.language.languages.unshift(JSON.parse(JSON.stringify(lang)));
  }
  save() {
    console.log(this.language);
    this.resumeService.updateLanguage(this.language).subscribe(res => {
      this.language.languages = res.resume.languages || [];
      this.router.navigate(['/resume/hobbies']);
    }, err => {
      console.log(err);
    });
  }
  remove(lang) {
    const index = this.language.languages.lastIndexOf(lang);
    this.language.languages.splice(index, 1);
    this.resumeService.updateLanguage(this.language).subscribe(res => {
      this.language.languages = res.resume.languages || [];
    }, err => {
      console.log(err);
    });
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }
}
